import { RESPONSE } from '@factories/vasApiResponseConstants'
import { API_URL_FACTORY } from '@factories/apiUrlFactory'

export const pucSerive = async (regNo): Promise<any> => {
  try {
    const response = await fetch(API_URL_FACTORY.PUC_API(regNo))

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    // Return the fetched data
    return data
  } catch (err) {
    console.error(err, RESPONSE.ERROR_PUC_API)
    return null
  }
}
